import {useSelector} from "react-redux";
import {RootState} from "../store";
import {useEffect} from "react";
import Layout from "../components/common/Layout";
import {useNavigate, Outlet, useLocation} from "react-router-dom";
import { useCookies } from 'react-cookie'
import useSignin from "src/hooks/useSignIn";
import { ACCESS_TOKEN, AUTH_TOKEN } from "src/common/util";

export default function RootRouter({baseUrl}:{baseUrl:string}) {
  const [cookies, setCookie, removeCookie] = useCookies([ACCESS_TOKEN, AUTH_TOKEN]);
  const auth = useSelector((state:RootState) => state.auth);
  const navigate = useNavigate();
  const location = useLocation();
  const { goSignin } = useSignin();

  useEffect(() => {
    if (!auth.user && cookies[AUTH_TOKEN]) {
      goSignin();
    } else if(!auth.user) {
      navigate('/signin');
    } else {
      if (location.pathname === '/' || location.pathname === '/signin') {
        navigate(`/${baseUrl}`);
      }
    }
  }, [auth]);

  return (
    cookies[AUTH_TOKEN] ? (
      <Layout>
        <Outlet /> {/* children */}
      </Layout>
    ): <Outlet />
  );
}